import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import { UIError } from '@/shared/utils/ui-error';
import type { AvailableCoupon } from '../types/available-coupon';

export type UseCaseInput = {
  storeSlug: string;
  isAuthenticated: boolean;
};

export type UseCaseOutput = AvailableCoupon[];

export class ListAvailableCouponsUseCase {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { storeSlug, isAuthenticated } = input;

    if (!storeSlug) {
      throw new UIError('STORE_REQUIRED', 'Loja é obrigatória');
    }

    if (!isAuthenticated) {
      // Return empty array if user is not authenticated
      // This prevents unnecessary API calls
      return [];
    }

    const response = await this.client.sendRequest<AvailableCoupon[], never>({
      endpoint: `api/app/merchants/${storeSlug}/checkout/coupons`,
      method: HttpMethod.GET,
    });

    // Filter only active coupons that should render in app
    return response.filter(coupon => coupon.is_active === 1 && coupon.render_in_app === 1);
  }
}
